import { useEffect, useState } from "react";
import { env } from "../../../env/env";
import "../PrintCheckoutPage";


export function OtherProducts({ page }: any) {
  const [products, setProducts] = useState([] as any);
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (page === 'cart') {
      setTitle('We think you may also like...');
      setProducts([
        { title: 'Flyers', type: 'letter', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Flyers.webp' },
        { title: 'Stickers', type: 'sticker-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Stickers.webp' },
        { title: 'Table Tents', type: 'table-tent', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Table-Tent.webp' },
        { title: 'Food Labels', type: 'label-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Food-Labels.webp' },
        { title: 'Business Cards', type: 'biz-card-landscape', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Biz-Cards.webp' },
        { title: 'Comment Cards', type: 'comment-card-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/Comment-Cards.webp' },
      ]);
    } else if (page === 'success') {
      setTitle('We also print...');
      setProducts([
        { title: 'Flyers', type: 'letter', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Flyers.webp' },
        { title: 'Table Tents', type: 'table-tent', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Table-Tent.webp' },
        { title: 'Food Labels', type: 'label-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Food Labels.webp' },
        { title: 'Loyalty Cards', type: 'loyalty-card-landscape', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Loyalty-cards.webp' },
        { title: 'Tabletop Inserts', type: '', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/TT Inserts.webp' },
        { title: 'Business Cards', type: 'biz-card-landscape', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Biz-Cards.webp' },
        { title: 'Stickers', type: 'sticker-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Stickers.webp' },
        { title: 'Comment Cards', type: 'comment-card-portrait', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Comment Cards.webp' },
        { title: 'Sandwich Boards', type: '', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Sandwich Boards.webp' },
        { title: 'Rack Cards', type: '', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Rack Cards.webp' },
        { title: 'Gift Certificates', type: '', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Gift Certs.webp' },
        { title: 'Posters', type: '', thumb: 'https://timber.mhmcdn.com/site/marketing/printcheckout/successpage/Posters.webp' },
      ]);
    }

  }, [page]);

  return (
    <div className={`other-products ${page}-page`}>
      <h3>{title}</h3>

      <div className="tiles">
        {products.map((product: any) =>
          <div>
            <a href={`${env.timberContextPath}/design?size=${product.type}`}>
              <img src={product.thumb} alt={product.title} />
              <h4>{product.title}</h4>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
